import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import injectSheet from 'react-jss'
import compose from 'recompose/compose'
import text from 'public/assets/svg/hotspots/fill_circle.svg'
import photo from 'public/assets/svg/hotspots/photo_hotspot.svg'
import video from 'public/assets/svg/hotspots/video_hotspot.svg'
import panorama from 'public/assets/svg/hotspots/360_hotspot.svg'
import positionalMedia from 'public/assets/svg/positional_media/play_i.svg'

const iconNames = {
    text,
    photo,
    video,
    panorama,
    positionalMedia,
}

class IconAndTitlePreview extends PureComponent {
    constructor(props) {
        super(props)

        this.state = {
            style: {},
            offsetY: undefined,
            offsetX: undefined,
            topVal: undefined,
            widthVal: undefined,
            leftVal: undefined,
            heightVal: undefined,
        }
    }

    handleHoverOn = e => {
        const { onHover } = this.props
        onHover && onHover()
    }

    handleHoverOff = () => {
        const { onHoverExit, isVisible } = this.props
        if (isVisible && onHoverExit) {
            onHoverExit()
        }
    }

    handleMouseMove = e => {
        const { clientX, clientY, target } = e
        let { topVal, widthVal, leftVal, heightVal } = this.state

        // The transform animation changes the values yielded by getBoundingClientRect
        // This results in erratic animations in long or tall elements, such as the Pano
        // To avoid this we have to get the values once on mount, set them on state, then rely on those values
        if (!(topVal && widthVal && leftVal && heightVal)) {
            const { top, width, left, height, ...rest } = target.getBoundingClientRect()
            this.setState({
                topVal: top,
                widthVal: width,
                leftVal: left,
                heightVal: height,
            })
            topVal = top
            widthVal = width
            leftVal = left
            heightVal = height
        }

        const { onHover } = this.props
        onHover && onHover()
    }

    render() {
        const { classes, onClick, children, type } = this.props
        const { style, offsetX, offsetY } = this.state
        const childrenWithInjectedOffset = React.Children.map(children, child =>
            React.cloneElement(child, {
                offsetX,
                offsetY,
            })
        )
        return (
            <div
                className={classes.container}
                onClick={onClick}
                onMouseEnter={this.handleHoverOn}
                onMouseMove={this.handleMouseMove}
                onMouseLeave={this.handleHoverOff}
            >
                <PreviewElement offsetX={offsetX} offsetY={offsetY} type={type} {...style}>
                    {childrenWithInjectedOffset}
                </PreviewElement>
            </div>
        )
    }
}

IconAndTitlePreview.propTypes = {
    id: PropTypes.number,
    onHover: PropTypes.func,
    onClick: PropTypes.func,
}

IconAndTitlePreview.defaultProps = {
    maxDistortion: 0.25,
}

const styles = theme => ({
    container: {
        display: 'flex',
        maxWidth: '156px',
        padding: '0 10px',
    },
    icon: {
        paddingRight: '8px',
        maxWidth: '20px',
    },
})
const style = {
    container: {
        perspective: '2.5em',
        pointerEvents: 'all',
        zIndex: '501',
        height: ({ height }) => height,
        width: ({ width }) => width,
        minHeight: `40px`,
        maxWidth: `156px`,
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        borderRadius: '8px',
    },
}
const PreviewElement = injectSheet(styles)(({ classes, children, type }) => {
    return (
        <div className={classes.container}>
            <img
                alt={`${type === 'positionalMedia' ? 'Play' : type}`}
                className={classes.icon}
                src={`${iconNames[type]}`}
            />
            {children}
        </div>
    )
})

export default compose(injectSheet(style))(IconAndTitlePreview)
